const STRING_MAP = {
  automy: 1,
  'self-managed': 2,
};

const parse = (value) => {
  if (value === 1 || value === 2) return value;
  if (typeof value === 'number') return value;
  if (typeof value === 'string') {
    const mapped = STRING_MAP[value.toLowerCase()];
    return mapped !== undefined ? mapped : null;
  }
  return null;
};

const isSelfManaged = (value) => parse(value) === 2;

export default Object.freeze({
  Automy: 1,
  SelfManaged: 2,
  parse,
  isSelfManaged,
});
